
class Callbacks {
  static filterToFormHandler(search_params) {
    return function filterToForm(filter) {
      const driver_id = _.head(search_params?.driver_id)
      const operator_id = _.head(search_params?.operator_id)
      const client_phone = _.head(search_params?.client_phone)
      const customer_number = _.head(search_params?.customer_number)
      return _.merge({},
        filter,
        !!driver_id && { transport: { assigned_transport: { driver: driver_id } } },
        !!operator_id && { billing: { operator: operator_id } },
        !!(client_phone || customer_number) && { quick: { do: { auth: { gsm: `+${client_phone || customer_number}` } } } }
      )
    }
  }
}

export default Callbacks
